import React, { Component, createContext } from 'react';
import { withApollo } from 'react-apollo';
import {
  find,
  head,
  prop,
  propEq,
  propOr,
} from 'ramda';
import { GET_TEAMS_QEURY } from './queries';


export const TeamContext = createContext();

TeamContext.getSelectedTeamId = () => localStorage.getItem('selected-team-id') || '';

const setSelectedTeamId = teamId => localStorage.setItem('selected-team-id', teamId);

class TeamProvider extends Component {
  state = {
    teams: [],
    selectedTeam: null,
    ready: false,
    error: null,
  }

  componentWillMount = () => {
    this.loadState();
  }

  selectTeam = (teamId) => {
    const teams = propOr([], 'teams', this.state);
    const selectedTeam = find(propEq('team_id', teamId), teams) || head(teams);

    setSelectedTeamId(prop('team_id', selectedTeam));
    this.setState({ selectedTeam });
  };

  fetchTeams = async () => {
    const { client, user } = this.props;

    const { data: { teams } } = await client.query({
      query: GET_TEAMS_QEURY,
      variables: { userID: user.user_id },
    });

    return teams;
  }

  loadState = async () => {
    try {
      const teams = await this.fetchTeams();
      const teamId = TeamContext.getSelectedTeamId();
      const selectedTeam = find(propEq('team_id', teamId), teams) || head(teams);
      const newState = { teams, selectedTeam, ready: true };

      this.setState(
        newState,
        () => setSelectedTeamId(prop('team_id', selectedTeam)),
      );
    } catch (error) {
      this.setState({ error: new Error('Unable to fetch teams from server') });
    }
  }

  render() {
    const {
      teams, selectedTeam, ready, error,
    } = this.state;
    const { children } = this.props;

    return (
      <TeamContext.Provider
        value={{
          teams,
          selectedTeam,
          ready,
          error,
          selectTeam: this.selectTeam,
        }}
      >
        {children}
      </TeamContext.Provider>
    );
  }
}

export default withApollo(TeamProvider);
